import { Component, OnInit } from '@angular/core';
import { CommonService } from './../Services/common.service';
import { DatePipe } from '@angular/common';
import { Subject } from "rxjs";
import { AccountService, cardDetail } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CardServiceService } from '../Services/card-service.service';
import { Base64 } from 'js-base64';
import { saveAs } from 'file-saver';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-card-transaction-history',
  templateUrl: './card-transaction-history.component.html',
  standalone:false,
  styleUrls: ['./card-transaction-history.component.scss']
})
export class CardTransactionHistoryComponent implements OnInit {

  modalObservable: Subject<void> = new Subject<void>();
  ViewCardDetail: boolean = false;

  selectedMonth: string = "";
  Monthlist
  FundNamelist
  MonthYear:string="";

  selectedTrasactions: string = "All Trasactions";
  Trasactionslist
  UnGroupCardTransactionHistory;
  GroupCardTransactionHistory
  AccountType: any;
  selectedItem: any;
  // selectedTransactionHistory
  constructor(private route: ActivatedRoute, private location: Location,    private toastr: ToastrService,
    private account: AccountService, public datepipe: DatePipe, public commonP: CommonService,public auth:AuthService,public _router:Router,public cardService:CardServiceService) { }
  cardDetail;
  selectedCardIndex: number;
  selectedCardDetail:cardDetail;
  showTransaction:boolean=false;
  enableViewCard:boolean=true;
  ViewStatementList;
  Downloadstatement;
  internalId
  EmailIds:string="";

  async ngOnInit(): Promise<void> {
    this.Trasactionslist = [
      // {
      //   iconClass: "",
      //   displayValue: "Unbilled",
      // }
      {
        iconClass: "",
        displayValue: "LAST 10 TRANSACTIONS",

      },
      {
        iconClass: "",
        displayValue: "HOLD",

      },
      {
        iconClass: "",
        displayValue: "CURRENT",

      }, {
        iconClass: "",
        displayValue: "PREVIOUS",

      }
    ],
    this.Monthlist = [
      {
        iconClass: "",
        displayValue: "January",
      },{
        iconClass: "",
        displayValue: "Febuary",
      }, {
        iconClass: "",
        displayValue: "March",
      }, {
        iconClass: "",
        displayValue: "April",
      }, {
        iconClass: "",
        displayValue: "May",
      }, {
        iconClass: "",
        displayValue: "June",
      }, {
        iconClass: "",
        displayValue: "July",
      }, {
        iconClass: "",
        displayValue: "August",
      }, {
        iconClass: "",
        displayValue: "September",
      }, {
        iconClass: "",
        displayValue: "October",
      }, {
        iconClass: "",
        displayValue: "November",
      }, {
        iconClass: "",
        displayValue: "December",
      }
    ]
    this.route.queryParams.subscribe(params => {
      if(params['id']){

        this.internalId=params['id'];
      }if(params['MonthYear']){
        this.MonthYear=params['MonthYear']
      }
      if(params['type']){
        this.AccountType = params['type'];
      }

    });


    let body={
      internalId: this.internalId,
  transactionType:"Statement",
  monthYear:this.MonthYear,
  downloadType: "Data",
  email: false,
  emailId:''

    }

    this.commonP.presentLoading();

    this.auth.accessToken = await this.commonP.Get("token");
    await this.commonP.presentLoading();

    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {  
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {

            this.cardService.CardStatement(body,this.auth.accessToken).then((data:any)=>{
              if(data?.response?.code==1){
                this.commonP.hideLoading();
                this.EmailIds=this.auth?.detailuser?.emailId;
                this.ViewStatementList=data.response.content.lst
                console.log('CardStatement', this.ViewStatementList);
                // this.showModal(num);
              }else{
                
                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert('', '', this._router, data);
              }
          
          
          
            })
          

          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });

 




    // if (this.account.getDashboardDetail?.cardDetails == undefined) {
    //   this.auth.accessToken = await this.commonP.Get("token");
    //   await this.commonP.presentLoading();

    //   this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
    //     if (data.response) {
    //       if (data.response.code) {
    //         if (data.response.code == 1) {
    //           this.account.GetLoanDashboard(this.auth.accessToken).then((data: any) => {
    //             if (data?.response?.code == 1) {
    //               
    //               let CardDetails = data.response.content.cardDetails;
    //               this.cardDetail = CardDetails.filter(x => x.displayFlag == 'Y');
    //               this.selectedCardDetail = this.cardDetail[0];
    //               // this.cardDetail=[];
    //               let body = {
    //                 internalId: this.selectedCardDetail?.internalId,
    //                 numberOfTransactions: "10",
    //                 transactionType: "Last"
    //               }
    //               if (this.selectedCardDetail?.freezed == 'N' && this.selectedCardDetail?.stopped == 'N') {


    //                 
    //                 this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
    //                   if (data?.response?.code == 1) {
    //                     
    //                     this.commonP.hideLoading();
    //                     let CardTransactionHistory = data.response.content.cardTransactions;
    //                     this.UnGroupCardTransactionHistory = CardTransactionHistory
    //                     this.selectedCardIndex = 0;
    //                     ('data', data.response.content);
    //                     // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
    //                     // this.selectedCardDetail=this.cardDetail[0];
    //                   } else {
    //                     
    //                     this.commonP.hideLoading();
    //                     this.commonP.ParseErrorAlert('', '', this._router, data);
    //                   }



    //                 })
    //                 this.showTransaction = true

    //               } else if (this.selectedCardDetail?.freezed == 'Y') {
    //                 
    //                 this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
    //                   if (data?.response?.code == 1) {
    //                     
    //                     this.commonP.hideLoading();
    //                     let CardTransactionHistory = data.response.content.cardTransactions;
    //                     this.UnGroupCardTransactionHistory = CardTransactionHistory
    //                     this.selectedCardIndex = null;
    //                     ('data', data.response.content.cardTransactions);
    //                     // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
    //                     // this.selectedCardDetail=this.cardDetail[0];
    //                   } else {
    //                     
    //                     this.commonP.hideLoading();
    //                     this.commonP.ParseErrorAlert('', '', this._router, data);
    //                   }



    //                 })
    //                 this.showTransaction = true;

    //               } else if (this.selectedCardDetail?.stopped == 'Y') {
    //                 
    //                 this.commonP.hideLoading();
    //                 this.selectedCardIndex = 0;
    //                 this.showTransaction = false;
    //               }
    //             } else {
    //               this.commonP.hideLoading();
    //               this.commonP.ParseErrorAlert('', '', this._router, data);
    //             }
    //           })

    //         } else {
    //           await this.commonP.hideLoading();
    //           this.commonP.ParseErrorAlert("", "", this._router, data);
    //         }
    //       } else {
    //         await this.commonP.hideLoading();
    //         this.commonP.ParseErrorAlert("", "", this._router, data);
    //       }
    //     } else {
    //       await this.commonP.hideLoading();
    //       this.commonP.ParseErrorAlert("", "", this._router, data);
    //     }
    //   });

    // } else {
    //   
    //   let CardDetails = this.account.getDashboardDetail?.cardDetails;
    //   this.cardDetail = CardDetails.filter(x => x.displayFlag == 'Y');
    //   this.selectedCardDetail = this.cardDetail[0];
    //   let body = {
    //     internalId: this.selectedCardDetail?.internalId,
    //     numberOfTransactions: "10",
    //     transactionType: "Last"
    //   }

    //   await this.commonP.presentLoading()
    //   if (this.selectedCardDetail?.freezed == 'N' && this.selectedCardDetail?.stopped == 'N') {
    //     
    //     this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
    //       if (data?.response?.code == 1) {
    //         this.commonP.hideLoading();
    //         let CardTransactionHistory = data.response.content.cardTransactions;
    //         this.UnGroupCardTransactionHistory = CardTransactionHistory
    //         this.selectedCardIndex = 0;
    //         this.showTransaction = true
    //         ('data', data.response.content.cardTransactions);
    //         // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
    //         // this.selectedCardDetail=this.cardDetail[0];
    //       } else {
    //         this.commonP.hideLoading();
    //         this.commonP.ParseErrorAlert('', '', this._router, data);
    //       }



    //     })


    //   }
    //   else if (this.selectedCardDetail?.freezed == 'Y') {
    //     
    //     this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
    //       if (data?.response?.code == 1) {
    //         this.commonP.hideLoading();
    //         let CardTransactionHistory = data.response.content.cardTransactions;
    //         this.UnGroupCardTransactionHistory = CardTransactionHistory
    //         this.selectedCardIndex = 0;
    //         this.showTransaction = true
    //         ('data', data.response.content.cardTransactions);
    //         // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
    //         // this.selectedCardDetail=this.cardDetail[0];
    //       } else {
    //         this.commonP.hideLoading();
    //         this.commonP.ParseErrorAlert('', '', this._router, data);
    //       }



    //     })


    //   }
    //   else if (this.selectedCardDetail?.stopped == 'Y') {
    //     
    //     this.commonP.hideLoading();
    //     this.selectedCardIndex = 0;
    //     this.showTransaction = false;

    //   }

    // }
  }

  selectCard(e) {
    this.selectedCardDetail=this.cardDetail[e]
    this.enableViewCard=false;
    // ('selectedCardDetail', this.selectedCardDetail);
    if(this.selectedCardDetail?.freezed=='N' && this.selectedCardDetail?.stopped=='N'){
        this.selectedCardIndex = e;
        this.commonP.presentLoading();
      this.getCardTransactionUnGroup(this.selectedCardDetail?.internalId);
      
      this.showTransaction=true

    }else if(this.selectedCardDetail?.freezed=='Y'){
      this.selectedCardIndex = null;
      this.commonP.presentLoading();
      this.getCardTransactionUnGroup(this.selectedCardDetail?.internalId);
      this.showTransaction=true;

    }else if(this.selectedCardDetail?.stopped=='Y'){
      this.selectedCardIndex = e;
      this.ViewCardDetail=false;
      this.showTransaction=false;

    } else{
      this.selectedCardIndex =null
      this.showTransaction=false;

    }
    // this.getCardTransactionUnGroup(this.selectedCardDetail?.internalId)
  }
getCardTransactionUnGroup(id){
  
  let body={
    internalId: id,
   numberOfTransactions: "10",
  transactionType:"Last"
  }
  this.cardService.GetTransactionUngroup(body,this.auth.accessToken).then((data:any)=>{
    if(data?.response?.code==1){
      
      this.commonP.hideLoading();
      let CardTransactionHistory=data.response.content.cardTransactions;
      this.UnGroupCardTransactionHistory=CardTransactionHistory
      ('data',data.response.content);
      // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
      // this.selectedCardDetail=this.cardDetail[0];
    }else{
      
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert('', '', this._router, data);
    }



  })


}
// getClass(index,card){
//   if(card.stopped=='N' && card.freezed=='N'){
//    return ''
//   }else if(card.stopped=='Y'){
//     return;

//   }else if(card.freezed=='Y'){
//     return 'freezed'
//   }

  
  
  


// }

getClass(index, card): string {
  if(card.stopped=='N' && card.freezed=='N'){
    return ''
  } else if(card.stopped=='Y'){
    return '';
  } else if(card.freezed=='Y'){
    return 'freezed'
  }
  return '';
}

  onMonthChange(event) {
    this.selectedMonth = event.displayValue;
   this.MonthYear=event.value;
  }

  onTrasactionsChange(event) {
    this.selectedTrasactions = event.displayValue;
    if(this.selectedTrasactions!=='LAST 10 TRANSACTIONS'){
      this.commonP.presentLoading();
      let body={
        internalId:this.selectedCardDetail?.internalId,
       numberOfTransactions: 0,
      transactionType:this.selectedTrasactions
      }
      this.cardService.GetTransactiongroup(body,this.auth.accessToken).then((data:any)=>{
        if(data?.response?.code==1){
          
          this.commonP.hideLoading();
          this.UnGroupCardTransactionHistory=[];
          let GroupCardTransactionHistory=data?.response?.content;
          this.GroupCardTransactionHistory=GroupCardTransactionHistory
          // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
          // this.selectedCardDetail=this.cardDetail[0];
        }else{
          
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', '', this._router, data);
        }
    
    
    
      })

    }else{
      this.commonP.presentLoading();
      let body={
        internalId:this.selectedCardDetail?.internalId,
       numberOfTransactions: 10,
      transactionType:'Last'
      }
      this.cardService.GetTransactiongroup(body,this.auth.accessToken).then((data:any)=>{
        if(data?.response?.code==1){
          
          this.commonP.hideLoading();
          this.UnGroupCardTransactionHistory=[];
          let GroupCardTransactionHistory=data?.response?.content;
          this.GroupCardTransactionHistory=GroupCardTransactionHistory
          // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
          // this.selectedCardDetail=this.cardDetail[0];
        }else{
          
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', '', this._router, data);
        }
    
    
    
      })
    }

    
  }
getMonthsDates(num){
  this.commonP.presentLoading();
  this.cardService.GetCardDates({InternalId:this.selectedCardDetail?.internalId},this.auth.accessToken).then((data:any)=>{
    if(data?.response?.code==1){
      this.commonP.hideLoading();
      let MonthsList=data.response.content;
      this.Monthlist=MonthsList.map(x=>({
        displayValue:x.displayValue,
        value:x.value
      }))

      this.showModal(num);
    }else{
      
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert('', '', this._router, data);
    }



  })

}
  showModal(num) {
    this.modalObservable.next(num);
  }
  back() {
    this._router.navigateByUrl("/DashboardCreditCards");
  }

  EnableViewCard(){
    
    if(this.enableViewCard){
      this.ViewCardDetail=false;
    }else{
      this.ViewCardDetail=true;
    }

  }
  UpdateCardStatus(status){
    let body={
      InternalId:this.selectedCardDetail?.internalId,
      Status:status,
      StopReasonCode:''

    }
    this.commonP.presentLoading();
    this.cardService.UpdateCardStatus(body,this.auth.accessToken).then((data:any)=>{
      if(data?.response?.code==1){
        
        if(data.response.content.status){
          this.account.GetLoanDashboard(this.auth.accessToken).then((data:any)=>{
            if(data?.response?.code==1){
              let CardDetails=data.response.content.cardDetails;
              this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
              this.selectedCardDetail=this.cardDetail[0];
              // this.cardDetail=[];
              let body={
                internalId: this.selectedCardDetail?.internalId,
               numberOfTransactions: "10",
              transactionType:"Last"
              }
              if(this.selectedCardDetail?.freezed=='N' && this.selectedCardDetail?.stopped=='N'){


               
                this.cardService.GetTransactionUngroup(body,this.auth.accessToken).then((data:any)=>{
                  if(data?.response?.code==1){
                    
                    this.commonP.hideLoading();
                    let CardTransactionHistory=data.response.content.cardTransactions;
                    this.UnGroupCardTransactionHistory=CardTransactionHistory
                    this.selectedCardIndex=0;
                    // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                    // this.selectedCardDetail=this.cardDetail[0];
                  }else{
                    
                    this.commonP.hideLoading();
                    this.commonP.ParseErrorAlert('', '', this._router, data);
                  }
              
              
              
                })
                this.showTransaction=true

              }else if(this.selectedCardDetail?.freezed=='Y'){
                this.cardService.GetTransactionUngroup(body,this.auth.accessToken).then((data:any)=>{
                  if(data?.response?.code==1){
                    
                    this.commonP.hideLoading();
                    let CardTransactionHistory=data.response.content.cardTransactions;
                    this.UnGroupCardTransactionHistory=CardTransactionHistory
                    this.selectedCardIndex=null;
                    // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                    // this.selectedCardDetail=this.cardDetail[0];
                  }else{
                    
                    this.commonP.hideLoading();
                    this.commonP.ParseErrorAlert('', '', this._router, data);
                  }
              
              
              
                })
                this.showTransaction=true;

              }else if(this.selectedCardDetail?.stopped=='Y'){
                this.selectedCardIndex=0;
                this.showTransaction=false;
              }
            }else{
              this.commonP.hideLoading();
              this.commonP.ParseErrorAlert('', '', this._router, data);
            }
          })

        }else{
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', '', this._router, data);
        }      
        // let CardTransactionHistory=data.response.content.cardTransactions;
        // this.CardTransactionHistory=CardTransactionHistory
        // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
        // this.selectedCardDetail=this.cardDetail[0];
      }else{
        
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);
      }
  
  
  
    })

  }
  ViewStatement(num){
    let body={
      internalId:this.selectedCardDetail?.internalId,
  transactionType:"Statement",
  monthYear:this.MonthYear,
  downloadType: "Data",
  email: false,
  emailId:''

    }

    this.commonP.presentLoading();
  this.cardService.CardStatement(body,this.auth.accessToken).then((data:any)=>{
    if(data?.response?.code==1){
      this.commonP.hideLoading();
      this.ViewStatementList=data.response.content.lst
      this.showModal(num);
    }else{
      
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert('', '', this._router, data);
    }



  })
    

  }

  getDate(dateTime: string): string {
    if (!dateTime) return '';
    return dateTime.split(' ')[0]; // Extracts the date part
  }
  
  getTime(dateTime: string): string {
    if (!dateTime) return '';
    return dateTime.split(' ')[1]; // Extracts the time part
  }
  

  handleClick(items, num) {

    this.selectedItem = items?.cardTransactions[0];
    console.log(this.selectedItem,"datamargya yaha");
     // Set the selected item
    this.showModal(num);

    
}
// handleClick(items: any, num: number): void {
//   this.selectedItem = items.cardTransactions[0]; // Store the selected item
//   this.showModal(num); // Show the modal
// }

 DownloadStatement(){
  let body={
    internalId:this.internalId,
// transactionType:"Statement",  
transactionType:"STATEMENT",
monthYear:this.MonthYear,
// downloadType: "PDF",
downloadType: "base64",
email: false,
emailId:''

  }

  this.commonP.presentLoading();
this.cardService.CardStatement(body,this.auth.accessToken).then((data:any)=>{
  if(data?.response?.code==1){
    this.commonP.hideLoading();
    // For Download file 
    let decodedData = Base64.decode(data.response.content.base64);
    let blob = new Blob([decodedData], { type: 'application/pdf' });
    saveAs(blob, data.response.content.fileName);
    
    // For Open in new tab
    
    // let fileUrl = URL.createObjectURL(blob);
     // window.open(fileUrl, '_blank');
   



  }else{
    
    this.commonP.hideLoading();
    this.commonP.ParseErrorAlert('', '', this._router, data);
  }



})

 }



// yousuf statment code
DownloadStatementcard(date) {

  let d = date.split(" ");
  // let body = {
  //   internalId: this.selectedCardDetail?.internalId,
  //   // transactionType: "Statement",
  //   transactionType: "STATEMENT",
  //   monthYear: this.MonthYear,
  //   downloadType: "base64",
  //   email: false,
  //   emailId: ''

  // }

  d = new Date(date[0].replace(/(\d+)(\d{2})/g, "$1-$2"));
  d = this.datepipe.transform(d, "YYYYMM");

  let body = {
    internalId: this.selectedCardDetail?.internalId,
    numberOfTransactions: null,
    // transactionType: "download",
    transactionType: "STATEMENT",
    // downloadType: "pdf",

    monthYear: date ? d : this.MonthYear,
    downloadType: "base64",
    email: false,
    emailId: "",
  };

  this.commonP.presentLoading();
  this.cardService
    .CardStatement(body, this.auth.accessToken)
    .then((data: any) => {
      if (data?.response?.code == 1) {
        this.commonP.hideLoading();
        // For Download file
        let decodedData = Base64.decode(data.response.content.base64);
        let blob = new Blob([decodedData], { type: "image/png" });
        saveAs(blob, data.response.content.fileName);

        // For Open in new tab

        // let fileUrl = URL.createObjectURL(blob);
        // window.open(fileUrl, '_blank');
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
}



 SendStatementToEmail(){
  let body={
    internalId:this.internalId,
// transactionType:"Email",
transactionType:"STATEMENT",
monthYear:this.MonthYear,
// downloadType: "",
downloadType: "EMAIL",
email: true,
emailId:this.EmailIds

  }

  this.commonP.presentLoading();
this.cardService.CardStatement(body,this.auth.accessToken).then((data:any)=>{
  if(data?.response?.code==1){
    this.commonP.hideLoading();
    //this.commonP.showSuccessToast('You should receive your statement in your inbox at '+this.EmailIds,'Your Email Was Sent Successfully');
    this.toastr.success('You should receive your statement in your inbox at '+this.EmailIds,'Your statement has been sent'  );
    // this.toastr.success(
    //   "You have succesfully updated the nickname of your selected loan",
    //   "Your statement has been sent"
    // );
  }else{
    
    this.commonP.hideLoading();
    this.commonP.ParseErrorAlert('', '', this._router, data);
  }



})

 }


  isValid(){
    if(this.selectedMonth){
      return false

    }else{
      return true

    }
  }
  isValidEmail(){
    if(this.EmailIds){
      return false
    }else{
      return true
    }
  }
} 




